import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [{ title: 'Kogia | Terms of Service' }]

export default function MembersTermsOfServiceRoute() {
	return (
		<div className="mx-auto flex max-w-screen-lg flex-col gap-12 p-4 pb-20 md:pt-10">
			<div className="flex flex-col gap-2">
				<h2 className="mb-4 font-serif text-h2">
					Terms and Conditions: Image Licensing Agreement
				</h2>
				<p>Last updated: April 15th, 2024</p>
				<p>
					Please read the following terms and conditions carefully. By ticking
					the box for &ldquo;I agree to the terms and conditions herein&rdquo;,
					you agree to be bound by this agreement.
				</p>
				<p>
					<strong className="text-h5 font-bold">1. Service Description</strong>
				</p>
				<p>
					The Kogia Oceanic Library, operated by Kogia, is a nonprofit free
					media library of marine photography and video content. The purpose of
					the Library is to support small conservation organizations,
					nonprofits, scientists, researchers, activists, and educators working
					to protect our oceans by providing access to high-quality media.
				</p>
				<p>
					<strong className="text-h5 font-bold">2. Usage Terms</strong>
				</p>
				<p>
					<strong className="text-h5 font-bold">2.1 Permitted Uses:</strong>
				</p>
				<p>
					You (&quot;User&quot;) may use the media provided by the Kogia Oceanic
					Library for the following purposes:
				</p>
				<ul className="list-inside list-[auto]">
					<li>Non-commercial videos (educational, conservation, campaigns)</li>
					<li>Nonprofit fundraising (videos, pitches, materials)</li>
					<li>Social Media</li>
					<li>Web usage</li>
					<li>Educational exhibitions</li>
					<li>Educational printed materials</li>
					<li>Awareness/Conservation/Activist Campaigns</li>
					<li>Small-scale art projects</li>
				</ul>
				<p>
					<strong className="text-h5 font-bold">2.2 Prohibited Uses:</strong>
				</p>
				<p>User shall not:</p>
				<ul className="list-inside list-[auto]">
					<li>
						Sell, give away, or sublicense to third parties (other people or
						organizations)
					</li>
					<li>Sell or give away as prints using Kogia media</li>
					<li>
						Use media sourced from outside the Oceanic Library section of
						Kogia&rsquo;s website
					</li>
				</ul>
				<p>
					<strong className="text-h5 font-bold">3. Termination</strong>
				</p>
				<p>
					Either party has the right to terminate the membership at any point.
				</p>
				<p>
					<strong className="text-h5 font-bold">4. Crediting</strong>
				</p>
				<p>
					User agrees to provide appropriate credit to Kogia and the contributor
					whenever possible, in order to support ongoing ocean conservation
					efforts. User shall adhere to the following guidelines for crediting
					Kogia across various platforms and uses:
				</p>
				<ul className="list-inside list-[auto]">
					<li>
						User shall use the watermarked versions of photos when possible
					</li>
					<li>
						On Social Media: User shall tag Kogia and credit the contributor in
						the caption when possible.
					</li>
					<li>
						On Web: User shall backlink Kogia&rsquo;s website (
						<a href="https://kogia.org" className="underline">
							https://kogia.org
						</a>
						) when possible.
					</li>
					<li>
						Partner Section on User&apos;s Website: User may include
						Kogia&rsquo;s logo in the partners section on User&apos;s website.
					</li>
					<li>
						In Videos: If video credits are included, User shall ensure to
						include Kogia and the contributor of footage within the credits when
						possible. If applicable, User shall include the contributor as well
						as Kogia in the video description as &quot;footage contributed by
						Kogia (with backlink).&quot;
					</li>
				</ul>
				<p>
					<strong className="text-h5 font-bold">
						5. Membership Duration and Media Usage
					</strong>
				</p>
				<p>
					<strong className="text-h5 font-bold">
						5.1 Membership Duration:
					</strong>
				</p>
				<p>
					Users may access and utilize the media provided by the Kogia Oceanic
					Library only for the duration of their valid membership.
				</p>
				<p>
					<strong className="text-h5 font-bold">5.2 Media Usage:</strong>
				</p>
				<p>
					Upon cancellation of membership, whether initiated by the member or by
					Kogia, the user forfeits all rights to use any media obtained from the
					Kogia Oceanic Library, even if such media was downloaded or accessed
					during the period of valid membership.
				</p>
				<p>
					<strong className="text-h5 font-bold">
						5.3 Termination of Membership:
					</strong>
				</p>
				<p>
					In the event of termination of membership, the user must promptly
					delete or otherwise cease using all media obtained from the Kogia
					Oceanic Library.
				</p>
				<p>
					<strong className="text-h5 font-bold">5.4</strong>{' '}
					<strong className="text-h5 font-bold">Misuse of Media:</strong>
				</p>
				<p>
					Misuse of media and violation of the Terms and Condition can result in
					termination of membership and potential legal recourse.
				</p>
				<p>
					<strong className="text-h5 font-bold">6. Miscellaneous</strong>
				</p>
				<p>
					Any amendments or modifications to this Agreement must be made in
					writing and signed by both parties.
				</p>
				<p>
					By ticking the box, you acknowledge and agree to abide by the terms
					and conditions herein.
				</p>
			</div>
		</div>
	)
}
